import {
  KProperty02ce7r476m8633 as KProperty0,
  KMutableProperty11e8g1gb0ecb9j as KMutableProperty1,
} from '../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { LocalDate31mqn6zavbpi8 as LocalDate } from '../LocalDate.mjs';
import { DateTimeFormatException2onfeknbywaob as DateTimeFormatException } from '../Exceptions.mjs';
import {
  DayOfWeek2xlo40o03f5e as DayOfWeek,
  get_isoDayNumberrycq4er3aoh9 as get_isoDayNumber,
} from '../DayOfWeek.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  hashCodeq5arwsb9dgti as hashCode,
  toString1pkumu07cwy4m as toString,
  createThis2j2avj17cvnv2 as createThis,
  equals2au1ep9vhcato as equals,
  protoOf180f3jzyo7rfj as protoOf,
  getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import {
  listOf1jh22dvmctj1r as listOf,
  get_indices3txodfl5wuu5j as get_indices,
} from '../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { IllegalArgumentException2asla15b5jaob as IllegalArgumentException } from '../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { charSequenceLength3278n89t01tmv as charSequenceLength } from '../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import { joinToString1cxrrlmo0chqs as joinToString } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { AppendableFormatStructure38mt32f1b8qva as AppendableFormatStructure } from '../internal/format/Builder.mjs';
import {
  appendAlternativeParsingImpl1mug8j87kp2j3 as appendAlternativeParsingImpl,
  appendOptionalImplcg29ds00y54b as appendOptionalImpl,
  chars1g48a4lypizqb as chars,
  build284bs2tzkjm2x as build,
  year$defaulto1ef087ubfdc as year$default,
  monthNumber$default3k7qk403bnffp as monthNumber$default,
  dayOfMonth$default2fd2gjqoxzh9x as dayOfMonth$default,
  AbstractDateTimeFormatBuilder2kkelk07l4wb as AbstractDateTimeFormatBuilder,
  WithDate2bqihss8t5xfv as WithDate,
  char1r4ssccmdfesy as char,
} from './DateTimeFormatBuilder.mjs';
import {
  AbstractDateTimeFormat1er9ki1vjeb1b as AbstractDateTimeFormat,
  Padding_ZERO_getInstance2hdjif6phlc74 as Padding_ZERO_getInstance,
  Padding_SPACE_getInstance7fwkzb4da6c as Padding_SPACE_getInstance,
} from './DateTimeFormat.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { BasicFormatStructure1rp1tyv3u2fjw as BasicFormatStructure } from '../internal/format/FormatStructure.mjs';
import {
  SignedIntFieldFormatDirective2ce7tjucbhgd2 as SignedIntFieldFormatDirective,
  UnsignedIntFieldFormatDirective20kfpdbszyixg as UnsignedIntFieldFormatDirective,
  NamedUnsignedIntFieldFormatDirective1yq6ki9eqgm4v as NamedUnsignedIntFieldFormatDirective,
} from '../internal/format/FieldFormatDirective.mjs';
import {
  PropertyAccessor1m9zk65ebkfc4 as PropertyAccessor,
  GenericFieldSpecnllvuuqbuxsd as GenericFieldSpec,
  UnsignedFieldSpec1pqzij1hidkca as UnsignedFieldSpec,
} from '../internal/format/FieldSpec.mjs';
import { _Char___init__impl__6a9atx2js6krycynjoo as _Char___init__impl__6a9atx } from '../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import { lazy2hsh8ze7j6ikd as lazy } from '../../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
function get_ISO_DATE() {
  _init_properties_LocalDateFormat_kt__k1uk9u();
  var tmp0 = ISO_DATE$delegate;
  var tmp = KProperty0();
  // Inline function 'kotlin.getValue' call
  getPropertyCallableRef('ISO_DATE', 0, tmp, _get_ISO_DATE_$ref_powsum(), null);
  return tmp0.f2();
}
var ISO_DATE$delegate;
function get_ISO_DATE_BASIC() {
  _init_properties_LocalDateFormat_kt__k1uk9u();
  var tmp0 = ISO_DATE_BASIC$delegate;
  var tmp = KProperty0();
  // Inline function 'kotlin.getValue' call
  getPropertyCallableRef('ISO_DATE_BASIC', 0, tmp, _get_ISO_DATE_BASIC_$ref_3fs8eb(), null);
  return tmp0.f2();
}
var ISO_DATE_BASIC$delegate;
function get_emptyIncompleteLocalDate() {
  _init_properties_LocalDateFormat_kt__k1uk9u();
  return emptyIncompleteLocalDate;
}
var emptyIncompleteLocalDate;
var IncompleteLocalDateClass;
function IncompleteLocalDate() {
  if (IncompleteLocalDateClass === VOID) {
    class $ {
      constructor(year, monthNumber, dayOfMonth, isoDayOfWeek) {
        year = year === VOID ? null : year;
        monthNumber = monthNumber === VOID ? null : monthNumber;
        dayOfMonth = dayOfMonth === VOID ? null : dayOfMonth;
        isoDayOfWeek = isoDayOfWeek === VOID ? null : isoDayOfWeek;
        this.j1p_1 = year;
        this.k1p_1 = monthNumber;
        this.l1p_1 = dayOfMonth;
        this.m1p_1 = isoDayOfWeek;
      }
      q1p(_set____db54di) {
        this.j1p_1 = _set____db54di;
      }
      p1o() {
        return this.j1p_1;
      }
      p1p(_set____db54di) {
        this.k1p_1 = _set____db54di;
      }
      q1o() {
        return this.k1p_1;
      }
      i1p(_set____db54di) {
        this.l1p_1 = _set____db54di;
      }
      r1o() {
        return this.l1p_1;
      }
      n1p(_set____db54di) {
        this.m1p_1 = _set____db54di;
      }
      o1p() {
        return this.m1p_1;
      }
      g1s() {
        var date = LocalDate().f1u(requireParsedField(this.j1p_1, 'year'), requireParsedField(this.k1p_1, 'monthNumber'), requireParsedField(this.l1p_1, 'dayOfMonth'));
        var tmp0_safe_receiver = this.m1p_1;
        if (tmp0_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          if (!(tmp0_safe_receiver === get_isoDayNumber(date.g1u()))) {
            throw DateTimeFormatException().y1m('Can not create a LocalDate from the given input: ' + ('the day of week is ' + DayOfWeek(tmp0_safe_receiver).toString() + ' but the date is ' + date.toString() + ', which is a ' + date.g1u().toString()));
          }
        }
        return date;
      }
      h1u(date) {
        this.j1p_1 = date.p1o();
        this.k1p_1 = date.q1o();
        this.l1p_1 = date.r1o();
        this.m1p_1 = get_isoDayNumber(date.g1u());
      }
      t1q() {
        return new (IncompleteLocalDate())(this.j1p_1, this.k1p_1, this.l1p_1, this.m1p_1);
      }
      equals(other) {
        var tmp;
        var tmp_0;
        var tmp_1;
        var tmp_2;
        if (other instanceof IncompleteLocalDate()) {
          tmp_2 = this.j1p_1 == other.j1p_1;
        } else {
          tmp_2 = false;
        }
        if (tmp_2) {
          tmp_1 = this.k1p_1 == other.k1p_1;
        } else {
          tmp_1 = false;
        }
        if (tmp_1) {
          tmp_0 = this.l1p_1 == other.l1p_1;
        } else {
          tmp_0 = false;
        }
        if (tmp_0) {
          tmp = this.m1p_1 == other.m1p_1;
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        // Inline function 'kotlin.hashCode' call
        var tmp0_safe_receiver = this.j1p_1;
        var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hashCode(tmp0_safe_receiver);
        var tmp$ret$0 = tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
        var tmp = imul(tmp$ret$0, 31);
        // Inline function 'kotlin.hashCode' call
        var tmp0_safe_receiver_0 = this.k1p_1;
        var tmp1_elvis_lhs_0 = tmp0_safe_receiver_0 == null ? null : hashCode(tmp0_safe_receiver_0);
        var tmp$ret$1 = tmp1_elvis_lhs_0 == null ? 0 : tmp1_elvis_lhs_0;
        var tmp_0 = tmp + imul(tmp$ret$1, 31) | 0;
        // Inline function 'kotlin.hashCode' call
        var tmp0_safe_receiver_1 = this.l1p_1;
        var tmp1_elvis_lhs_1 = tmp0_safe_receiver_1 == null ? null : hashCode(tmp0_safe_receiver_1);
        var tmp$ret$2 = tmp1_elvis_lhs_1 == null ? 0 : tmp1_elvis_lhs_1;
        var tmp_1 = tmp_0 + imul(tmp$ret$2, 31) | 0;
        // Inline function 'kotlin.hashCode' call
        var tmp0_safe_receiver_2 = this.m1p_1;
        var tmp1_elvis_lhs_2 = tmp0_safe_receiver_2 == null ? null : hashCode(tmp0_safe_receiver_2);
        var tmp$ret$3 = tmp1_elvis_lhs_2 == null ? 0 : tmp1_elvis_lhs_2;
        return tmp_1 + imul(tmp$ret$3, 31) | 0;
      }
      toString() {
        var tmp0_elvis_lhs = this.j1p_1;
        var tmp = toString(tmp0_elvis_lhs == null ? '??' : tmp0_elvis_lhs);
        var tmp1_elvis_lhs = this.k1p_1;
        var tmp_0 = toString(tmp1_elvis_lhs == null ? '??' : tmp1_elvis_lhs);
        var tmp2_elvis_lhs = this.l1p_1;
        var tmp_1 = toString(tmp2_elvis_lhs == null ? '??' : tmp2_elvis_lhs);
        var tmp3_elvis_lhs = this.m1p_1;
        return tmp + '-' + tmp_0 + '-' + tmp_1 + ' (day of week is ' + toString(tmp3_elvis_lhs == null ? '??' : tmp3_elvis_lhs) + ')';
      }
    }
    initMetadataForClass($, 'IncompleteLocalDate', IncompleteLocalDate);
    IncompleteLocalDateClass = $;
  }
  return IncompleteLocalDateClass;
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        this.c1r_1 = MonthNames().j1u(listOf(['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']));
        this.d1r_1 = MonthNames().j1u(listOf(['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']));
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
function String$toString$ref() {
  var l = (p0) => toString(p0);
  l.callableName = 'toString';
  return l;
}
var MonthNamesClass;
function MonthNames() {
  if (MonthNamesClass === VOID) {
    class $ {
      static j1u(names) {
        Companion_getInstance();
        var $this = createThis(this);
        $this.i1u_1 = names;
        // Inline function 'kotlin.require' call
        if (!($this.i1u_1.p1() === 12)) {
          var message = 'Month names must contain exactly 12 elements';
          throw IllegalArgumentException().a1(toString(message));
        }
        // Inline function 'kotlin.collections.forEach' call
        var progression = get_indices($this.i1u_1);
        var inductionVariable = progression.i2_1;
        var last = progression.j2_1;
        if (inductionVariable <= last)
          do {
            var element = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var ix = element;
            // Inline function 'kotlin.text.isNotEmpty' call
            var this_0 = $this.i1u_1.q1(ix);
            // Inline function 'kotlin.require' call
            if (!(charSequenceLength(this_0) > 0)) {
              var message_0 = 'A month name can not be empty';
              throw IllegalArgumentException().a1(toString(message_0));
            }
            var inductionVariable_0 = 0;
            if (inductionVariable_0 < ix)
              do {
                var ix2 = inductionVariable_0;
                inductionVariable_0 = inductionVariable_0 + 1 | 0;
                // Inline function 'kotlin.require' call
                if (!!($this.i1u_1.q1(ix) === $this.i1u_1.q1(ix2))) {
                  var message_1 = "Month names must be unique, but '" + $this.i1u_1.q1(ix) + "' was repeated";
                  throw IllegalArgumentException().a1(toString(message_1));
                }
              }
               while (inductionVariable_0 < ix);
          }
           while (!(element === last));
        return $this;
      }
      static k1u(january, february, march, april, may, june, july, august, september, october, november, december) {
        Companion_getInstance();
        return this.j1u(listOf([january, february, march, april, may, june, july, august, september, october, november, december]));
      }
      toString() {
        return joinToString(this.i1u_1, ', ', 'MonthNames(', ')', VOID, VOID, String$toString$ref());
      }
      equals(other) {
        var tmp;
        if (other instanceof MonthNames()) {
          tmp = equals(this.i1u_1, other.i1u_1);
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return hashCode(this.i1u_1);
      }
    }
    initMetadataForClass($, 'MonthNames');
    MonthNamesClass = $;
  }
  return MonthNamesClass;
}
var CompanionClass_0;
function Companion_0() {
  if (CompanionClass_0 === VOID) {
    class $ {
      constructor() {
        Companion_instance_0 = this;
        this.h1r_1 = DayOfWeekNames().m1u(listOf(['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday']));
        this.i1r_1 = DayOfWeekNames().m1u(listOf(['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']));
      }
    }
    initMetadataForCompanion($);
    CompanionClass_0 = $;
  }
  return CompanionClass_0;
}
var Companion_instance_0;
function Companion_getInstance_0() {
  if (Companion_instance_0 === VOID)
    new (Companion_0())();
  return Companion_instance_0;
}
function String$toString$ref_0() {
  var l = (p0) => toString(p0);
  l.callableName = 'toString';
  return l;
}
var DayOfWeekNamesClass;
function DayOfWeekNames() {
  if (DayOfWeekNamesClass === VOID) {
    class $ {
      static m1u(names) {
        Companion_getInstance_0();
        var $this = createThis(this);
        $this.l1u_1 = names;
        // Inline function 'kotlin.require' call
        if (!($this.l1u_1.p1() === 7)) {
          var message = 'Day of week names must contain exactly 7 elements';
          throw IllegalArgumentException().a1(toString(message));
        }
        // Inline function 'kotlin.collections.forEach' call
        var progression = get_indices($this.l1u_1);
        var inductionVariable = progression.i2_1;
        var last = progression.j2_1;
        if (inductionVariable <= last)
          do {
            var element = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var ix = element;
            // Inline function 'kotlin.text.isNotEmpty' call
            var this_0 = $this.l1u_1.q1(ix);
            // Inline function 'kotlin.require' call
            if (!(charSequenceLength(this_0) > 0)) {
              var message_0 = 'A day-of-week name can not be empty';
              throw IllegalArgumentException().a1(toString(message_0));
            }
            var inductionVariable_0 = 0;
            if (inductionVariable_0 < ix)
              do {
                var ix2 = inductionVariable_0;
                inductionVariable_0 = inductionVariable_0 + 1 | 0;
                // Inline function 'kotlin.require' call
                if (!!($this.l1u_1.q1(ix) === $this.l1u_1.q1(ix2))) {
                  var message_1 = "Day-of-week names must be unique, but '" + $this.l1u_1.q1(ix) + "' was repeated";
                  throw IllegalArgumentException().a1(toString(message_1));
                }
              }
               while (inductionVariable_0 < ix);
          }
           while (!(element === last));
        return $this;
      }
      static n1u(monday, tuesday, wednesday, thursday, friday, saturday, sunday) {
        Companion_getInstance_0();
        return this.m1u(listOf([monday, tuesday, wednesday, thursday, friday, saturday, sunday]));
      }
      toString() {
        return joinToString(this.l1u_1, ', ', 'DayOfWeekNames(', ')', VOID, VOID, String$toString$ref_0());
      }
      equals(other) {
        var tmp;
        if (other instanceof DayOfWeekNames()) {
          tmp = equals(this.l1u_1, other.l1u_1);
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return hashCode(this.l1u_1);
      }
    }
    initMetadataForClass($, 'DayOfWeekNames');
    DayOfWeekNamesClass = $;
  }
  return DayOfWeekNamesClass;
}
var CompanionClass_1;
function Companion_1() {
  if (CompanionClass_1 === VOID) {
    class $ {
      o1u(block) {
        var builder = new (Builder())(new (AppendableFormatStructure())());
        block(builder);
        return new (LocalDateFormat())(builder.m1r());
      }
    }
    initMetadataForCompanion($);
    CompanionClass_1 = $;
  }
  return CompanionClass_1;
}
var Companion_instance_1;
function Companion_getInstance_1() {
  return Companion_instance_1;
}
var BuilderClass;
function Builder() {
  if (BuilderClass === VOID) {
    class $ {
      constructor(actualBuilder) {
        this.p1u_1 = actualBuilder;
      }
      o1s() {
        return this.p1u_1;
      }
      w1s(structure) {
        return this.p1u_1.r1s(structure);
      }
      t1s() {
        return new (Builder())(new (AppendableFormatStructure())());
      }
    }
    protoOf($).u1s = appendAlternativeParsingImpl;
    protoOf($).v1s = appendOptionalImpl;
    protoOf($).g1r = chars;
    protoOf($).m1r = build;
    protoOf($).y1s = year;
    protoOf($).f1r = year$default;
    protoOf($).z1s = monthNumber;
    protoOf($).a1t = monthNumber$default;
    protoOf($).e1r = monthName;
    protoOf($).b1r = dayOfMonth;
    protoOf($).b1t = dayOfMonth$default;
    protoOf($).j1r = dayOfWeek;
    protoOf($).u1q = date;
    initMetadataForClass($, 'Builder', VOID, VOID, [AbstractDateTimeFormatBuilder(), AbstractWithDateBuilder()]);
    BuilderClass = $;
  }
  return BuilderClass;
}
var LocalDateFormatClass;
function LocalDateFormat() {
  if (LocalDateFormatClass === VOID) {
    class $ extends AbstractDateTimeFormat() {
      constructor(actualFormat) {
        super();
        this.q1u_1 = actualFormat;
      }
      o1t() {
        return this.q1u_1;
      }
      r1u(value) {
        // Inline function 'kotlin.apply' call
        var this_0 = new (IncompleteLocalDate())();
        this_0.h1u(value);
        return this_0;
      }
      q1t(value) {
        return this.r1u(value instanceof LocalDate() ? value : THROW_CCE());
      }
      s1u(intermediate) {
        return intermediate.g1s();
      }
      s1t(intermediate) {
        return this.s1u(intermediate instanceof IncompleteLocalDate() ? intermediate : THROW_CCE());
      }
      t1t() {
        return get_emptyIncompleteLocalDate();
      }
    }
    initMetadataForClass($, 'LocalDateFormat');
    LocalDateFormatClass = $;
  }
  return LocalDateFormatClass;
}
function requireParsedField(field, name) {
  _init_properties_LocalDateFormat_kt__k1uk9u();
  if (field == null) {
    throw DateTimeFormatException().y1m('Can not create a ' + name + ' from the given input: the field ' + name + ' is missing');
  }
  return field;
}
function year(padding) {
  return this.w1s(new (BasicFormatStructure())(new (YearDirective())(padding)));
}
function monthNumber(padding) {
  return this.w1s(new (BasicFormatStructure())(new (MonthDirective())(padding)));
}
function monthName(names) {
  return this.w1s(new (BasicFormatStructure())(new (MonthNameDirective())(names)));
}
function dayOfMonth(padding) {
  return this.w1s(new (BasicFormatStructure())(new (DayDirective())(padding)));
}
function dayOfWeek(names) {
  return this.w1s(new (BasicFormatStructure())(new (DayOfWeekDirective())(names)));
}
function date(format) {
  var tmp;
  if (format instanceof LocalDateFormat()) {
    this.w1s(format.q1u_1);
    tmp = Unit_instance;
  }
  return tmp;
}
var AbstractWithDateBuilderClass;
function AbstractWithDateBuilder() {
  if (AbstractWithDateBuilderClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'AbstractWithDateBuilder', VOID, VOID, [WithDate()]);
    AbstractWithDateBuilderClass = $;
  }
  return AbstractWithDateBuilderClass;
}
var YearDirectiveClass;
function YearDirective() {
  if (YearDirectiveClass === VOID) {
    class $ extends SignedIntFieldFormatDirective() {
      constructor(padding, isYearOfEra) {
        isYearOfEra = isYearOfEra === VOID ? false : isYearOfEra;
        var tmp = DateFields_getInstance().t1u_1;
        // Inline function 'kotlinx.datetime.format.minDigits' call
        var tmp_0 = padding.equals(Padding_ZERO_getInstance()) ? 4 : 1;
        // Inline function 'kotlinx.datetime.format.spaces' call
        super(tmp, tmp_0, null, padding.equals(Padding_SPACE_getInstance()) ? 4 : null, 4);
        this.c1v_1 = padding;
        this.d1v_1 = isYearOfEra;
      }
      equals(other) {
        var tmp;
        var tmp_0;
        if (other instanceof YearDirective()) {
          tmp_0 = this.c1v_1.equals(other.c1v_1);
        } else {
          tmp_0 = false;
        }
        if (tmp_0) {
          tmp = this.d1v_1 === other.d1v_1;
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return imul(this.c1v_1.hashCode(), 31) + getBooleanHashCode(this.d1v_1) | 0;
      }
    }
    initMetadataForClass($, 'YearDirective');
    YearDirectiveClass = $;
  }
  return YearDirectiveClass;
}
var MonthDirectiveClass;
function MonthDirective() {
  if (MonthDirectiveClass === VOID) {
    class $ extends UnsignedIntFieldFormatDirective() {
      constructor(padding) {
        var tmp = DateFields_getInstance().u1u_1;
        // Inline function 'kotlinx.datetime.format.minDigits' call
        var tmp_0 = padding.equals(Padding_ZERO_getInstance()) ? 2 : 1;
        // Inline function 'kotlinx.datetime.format.spaces' call
        super(tmp, tmp_0, padding.equals(Padding_SPACE_getInstance()) ? 2 : null);
        this.o1v_1 = padding;
      }
      equals(other) {
        var tmp;
        if (other instanceof MonthDirective()) {
          tmp = this.o1v_1.equals(other.o1v_1);
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return this.o1v_1.hashCode();
      }
    }
    initMetadataForClass($, 'MonthDirective');
    MonthDirectiveClass = $;
  }
  return MonthDirectiveClass;
}
var MonthNameDirectiveClass;
function MonthNameDirective() {
  if (MonthNameDirectiveClass === VOID) {
    class $ extends NamedUnsignedIntFieldFormatDirective() {
      constructor(names) {
        super(DateFields_getInstance().u1u_1, names.i1u_1, 'monthName');
        this.w1v_1 = names;
      }
      equals(other) {
        var tmp;
        if (other instanceof MonthNameDirective()) {
          tmp = equals(this.w1v_1.i1u_1, other.w1v_1.i1u_1);
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return hashCode(this.w1v_1.i1u_1);
      }
    }
    initMetadataForClass($, 'MonthNameDirective');
    MonthNameDirectiveClass = $;
  }
  return MonthNameDirectiveClass;
}
var DayDirectiveClass;
function DayDirective() {
  if (DayDirectiveClass === VOID) {
    class $ extends UnsignedIntFieldFormatDirective() {
      constructor(padding) {
        var tmp = DateFields_getInstance().v1u_1;
        // Inline function 'kotlinx.datetime.format.minDigits' call
        var tmp_0 = padding.equals(Padding_ZERO_getInstance()) ? 2 : 1;
        // Inline function 'kotlinx.datetime.format.spaces' call
        super(tmp, tmp_0, padding.equals(Padding_SPACE_getInstance()) ? 2 : null);
        this.e1w_1 = padding;
      }
      equals(other) {
        var tmp;
        if (other instanceof DayDirective()) {
          tmp = this.e1w_1.equals(other.e1w_1);
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return this.e1w_1.hashCode();
      }
    }
    initMetadataForClass($, 'DayDirective');
    DayDirectiveClass = $;
  }
  return DayDirectiveClass;
}
var DayOfWeekDirectiveClass;
function DayOfWeekDirective() {
  if (DayOfWeekDirectiveClass === VOID) {
    class $ extends NamedUnsignedIntFieldFormatDirective() {
      constructor(names) {
        super(DateFields_getInstance().w1u_1, names.l1u_1, 'dayOfWeekName');
        this.i1w_1 = names;
      }
      equals(other) {
        var tmp;
        if (other instanceof DayOfWeekDirective()) {
          tmp = equals(this.i1w_1.l1u_1, other.i1w_1.l1u_1);
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return hashCode(this.i1w_1.l1u_1);
      }
    }
    initMetadataForClass($, 'DayOfWeekDirective');
    DayOfWeekDirectiveClass = $;
  }
  return DayOfWeekDirectiveClass;
}
function DateFieldContainer$_get_year_$ref_fy14wc() {
  return (p0) => p0.p1o();
}
function DateFieldContainer$_set_year_$ref_sqxgd4() {
  return (p0, p1) => {
    p0.q1p(p1);
    return Unit_instance;
  };
}
function DateFieldContainer$_get_monthNumber_$ref_c94z1k() {
  return (p0) => p0.q1o();
}
function DateFieldContainer$_set_monthNumber_$ref_25erj0() {
  return (p0, p1) => {
    p0.p1p(p1);
    return Unit_instance;
  };
}
function DateFieldContainer$_get_dayOfMonth_$ref_c8x4t8() {
  return (p0) => p0.r1o();
}
function DateFieldContainer$_set_dayOfMonth_$ref_da6b88() {
  return (p0, p1) => {
    p0.i1p(p1);
    return Unit_instance;
  };
}
function DateFieldContainer$_get_isoDayOfWeek_$ref_amcy49() {
  return (p0) => p0.o1p();
}
function DateFieldContainer$_set_isoDayOfWeek_$ref_vbmus3() {
  return (p0, p1) => {
    p0.n1p(p1);
    return Unit_instance;
  };
}
var DateFieldsClass;
function DateFields() {
  if (DateFieldsClass === VOID) {
    class $ {
      constructor() {
        DateFields_instance = this;
        var tmp = this;
        var tmp_0 = KMutableProperty1();
        var tmp_1 = DateFieldContainer$_get_year_$ref_fy14wc();
        tmp.t1u_1 = new (GenericFieldSpec())(new (PropertyAccessor())(getPropertyCallableRef('year', 1, tmp_0, tmp_1, DateFieldContainer$_set_year_$ref_sqxgd4())));
        var tmp_2 = this;
        var tmp_3 = KMutableProperty1();
        var tmp_4 = DateFieldContainer$_get_monthNumber_$ref_c94z1k();
        tmp_2.u1u_1 = new (UnsignedFieldSpec())(new (PropertyAccessor())(getPropertyCallableRef('monthNumber', 1, tmp_3, tmp_4, DateFieldContainer$_set_monthNumber_$ref_25erj0())), 1, 12);
        var tmp_5 = this;
        var tmp_6 = KMutableProperty1();
        var tmp_7 = DateFieldContainer$_get_dayOfMonth_$ref_c8x4t8();
        tmp_5.v1u_1 = new (UnsignedFieldSpec())(new (PropertyAccessor())(getPropertyCallableRef('dayOfMonth', 1, tmp_6, tmp_7, DateFieldContainer$_set_dayOfMonth_$ref_da6b88())), 1, 31);
        var tmp_8 = this;
        var tmp_9 = KMutableProperty1();
        var tmp_10 = DateFieldContainer$_get_isoDayOfWeek_$ref_amcy49();
        tmp_8.w1u_1 = new (UnsignedFieldSpec())(new (PropertyAccessor())(getPropertyCallableRef('isoDayOfWeek', 1, tmp_9, tmp_10, DateFieldContainer$_set_isoDayOfWeek_$ref_vbmus3())), 1, 7);
      }
    }
    initMetadataForObject($, 'DateFields');
    DateFieldsClass = $;
  }
  return DateFieldsClass;
}
var DateFields_instance;
function DateFields_getInstance() {
  if (DateFields_instance === VOID)
    new (DateFields())();
  return DateFields_instance;
}
function ISO_DATE$delegate$lambda() {
  _init_properties_LocalDateFormat_kt__k1uk9u();
  var tmp = Companion_instance_1;
  return tmp.o1u(ISO_DATE$delegate$lambda$lambda);
}
function ISO_DATE$delegate$lambda$lambda($this$build) {
  _init_properties_LocalDateFormat_kt__k1uk9u();
  $this$build.f1r();
  char($this$build, _Char___init__impl__6a9atx(45));
  $this$build.a1t();
  char($this$build, _Char___init__impl__6a9atx(45));
  $this$build.b1t();
  return Unit_instance;
}
function _get_ISO_DATE_$ref_powsum() {
  return () => get_ISO_DATE();
}
function ISO_DATE_BASIC$delegate$lambda() {
  _init_properties_LocalDateFormat_kt__k1uk9u();
  var tmp = Companion_instance_1;
  return tmp.o1u(ISO_DATE_BASIC$delegate$lambda$lambda);
}
function ISO_DATE_BASIC$delegate$lambda$lambda($this$build) {
  _init_properties_LocalDateFormat_kt__k1uk9u();
  $this$build.f1r();
  $this$build.a1t();
  $this$build.b1t();
  return Unit_instance;
}
function _get_ISO_DATE_BASIC_$ref_3fs8eb() {
  return () => get_ISO_DATE_BASIC();
}
var properties_initialized_LocalDateFormat_kt_fmnlhc;
function _init_properties_LocalDateFormat_kt__k1uk9u() {
  if (!properties_initialized_LocalDateFormat_kt_fmnlhc) {
    properties_initialized_LocalDateFormat_kt_fmnlhc = true;
    ISO_DATE$delegate = lazy(ISO_DATE$delegate$lambda);
    ISO_DATE_BASIC$delegate = lazy(ISO_DATE_BASIC$delegate$lambda);
    emptyIncompleteLocalDate = new (IncompleteLocalDate())();
  }
}
//region block: init
Companion_instance_1 = new (Companion_1())();
//endregion
//region block: exports
export {
  Companion_getInstance_0 as Companion_getInstanceem9vodzsunmv,
  Companion_instance_1 as Companion_instance150ikn0lenahv,
  Companion_getInstance as Companion_getInstance2euvj2567gjrn,
  date as date3ki45iw426xr8,
  dayOfMonth as dayOfMonths8rfgqv9djoz,
  dayOfWeek as dayOfWeek16trujebvwhwq,
  monthName as monthNames1ujl7xt4e7x,
  monthNumber as monthNumber39ajqip9c32rn,
  year as year2o42o5s31g3p8,
  AbstractWithDateBuilder as AbstractWithDateBuilder1xwo9aqwqe32f,
  DayOfWeekNames as DayOfWeekNames2fcv38sn7lsy4,
  get_ISO_DATE as get_ISO_DATE1ah0stqy13618,
  get_ISO_DATE_BASIC as get_ISO_DATE_BASIC1k4wiybcckf8,
  IncompleteLocalDate as IncompleteLocalDate2wlnrm8wqbjky,
  MonthNames as MonthNamesfwvovzkezhlb,
  requireParsedField as requireParsedField387b2jr94jy2p,
};
//endregion

//# sourceMappingURL=LocalDateFormat.mjs.map
